import { createAction } from '@reduxjs/toolkit';

export const setFleetLineGeojson = createAction<GeoJSON.FeatureCollection>(
  'SET_FLEET_LINE_GEOJSON',
);

export const setFleetBoatGeojson = createAction<GeoJSON.FeatureCollection>(
  'SET_FLEET_BOAT_GEOJSON',
);
